module.exports = __webpack_public_path__ + "img/bbq.0de54512.jpg";